import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import { NodeVisualization } from './NodeVisualization';
import { ArrowRightIcon, PlayCircleIcon } from 'lucide-react';
export function HeroSection() {
  const navigate = useNavigate();
  return <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background grid */}
      <div className="absolute inset-0 bg-grid opacity-50" />

      {/* Gradient orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary-500/20 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-surface-700 border border-surface-500 rounded-full text-sm text-gray-300">
              <span className="w-2 h-2 bg-success-400 rounded-full animate-pulse" />
              Now in public beta
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
              <span className="text-white">Turn your entire job into an </span>
              <span className="text-gradient">
                executable, self-documenting graph.
              </span>
            </h1>

            <p className="text-xl text-gray-400 leading-relaxed max-w-xl">
              StreamGraph transforms how you work. Define streams, let AI agents
              execute tasks in parallel, and watch documentation generate
              itself. Work is a graph—finally, there's a tool that sees it that
              way.
            </p>

            <div className="flex flex-wrap gap-4">
              <Button size="lg" rightIcon={<ArrowRightIcon className="w-5 h-5" />} onClick={() => navigate('/dashboard')}>
                Start Building
              </Button>
              <Button variant="ghost" size="lg" leftIcon={<PlayCircleIcon className="w-5 h-5" />}>
                See how it works
              </Button>
            </div>

            {/* Social proof */}
            <div className="flex items-center gap-6 pt-4">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gradient-to-br from-primary-400 to-purple-500 border-2 border-surface-800" />)}
              </div>
              <p className="text-sm text-gray-400">
                <span className="text-white font-semibold">2,000+</span> teams
                already building
              </p>
            </div>
          </div>

          {/* Right visualization */}
          <div className="relative lg:h-[500px] h-[300px]">
            <div className="absolute inset-0 bg-gradient-to-r from-surface-900 via-transparent to-surface-900 z-10 pointer-events-none lg:hidden" />
            <NodeVisualization />
          </div>
        </div>
      </div>
    </section>;
}